// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loading_loader__iusB_","rotate":"Loading_rotate__AYGVa","prixClipFix":"Loading_prixClipFix__nFFQc"};